(() => {
    window.addEventListener("DOMContentLoaded", () => {
        let consultingRequestSelect = document.querySelector('#sendsystemselector #consulting-request')

        if (!consultingRequestSelect) {
            return
        }

        const changeHandler = () => {
            document
              .querySelector('#sendsystemselector')
              .setAttribute('action', consultingRequestSelect.value)
        }

        changeHandler()

        consultingRequestSelect.addEventListener('change', changeHandler)
    })
}) ()

